import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FilterService } from '../../services/filter.service';
import { TabModel } from '../../model/tab.model';
import { ButtonTheme } from '@shared/enums/button-theme.enum';

@Component({
  selector: 'app-filter-button',
  templateUrl: './filter-button.component.html',
  styleUrls: ['./filter-button.component.scss'],
})
export class FilterButtonComponent {
  @Input() filterNavigationConfig: TabModel = null;
  @Output() clicked = new EventEmitter();
  @Input() theme: ButtonTheme = ButtonTheme.Flat;
  @Input() size: 'xs' | 'sm' | 'md' = 'md';
  @Input() isPrimaryLightColor = false;
  @Input() isDisabled = false;

  constructor(private filterService: FilterService) {}

  onFilterButtonClicked() {
    this.filterService.filterNavigationConfig$.next(this.filterNavigationConfig);
    this.clicked.emit();
  }
}
